
































import { Vue, Component, Prop, Ref } from "vue-property-decorator"
import { FormSchemaItem } from "./constant"
import SelectTree from "@/components/selectTree.vue"
import UploadFile from "@/components/upload-file/index.vue"
import commonService from "@/services/common.service"
import { FormModel } from "ant-design-vue"
@Component({
    components: {
        SelectTree,
        UploadFile
    }
})
export default class PartForm extends Vue {
    @Ref("form")
    refForm: FormModel

    // 标题
    @Prop({ type: String, default: "" })
    title: string
    // 一行的 DescriptionItems 数量
    @Prop({ type: [Number, Object], default: 3 })
    column: number | { xs?: number; sm?: number; md?: number }

    @Prop({ type: Object, default: (): any => ({}) })
    model: Record<string, any>

    @Prop({ type: Array, default: (): any => [] })
    schema: FormSchemaItem[]

    @Prop({ type: Number, default: 110 })
    labelWidth: number

    async customUpload(option: any) {
        const {
            url,
            view_url,
            attachment_id,
            real_name,
            show_name
        } = await commonService.uploadFile(option.file, e => {
            console.log("上传进度", e)
        })
        return {
            url: url,
            view_url,
            attachment_id,
            real_name,
            show_name,
            uid: (option.file as any).uid,
            name: show_name,
            status: "done"
        }
    }

    validate() {
        return this.refForm.validate()
    }
}
